/**
 * โพล์ตรวจ session กับ user-auth เป็นระยะ
 * เมื่อล็อกอินจาก browser/อุปกรณ์อื่น backend จะตั้ง currentSessionIssuedAt ใหม่
 * การเรียก user-auth (เช่น GET /profile) จะได้ 401 SESSION_REPLACED
 * apiRequest จะเรียก handleSessionReplaced ให้เอง
 */
import { useEffect, useRef } from 'react'
import { apiRequest } from '../services/apiRequest'

const POLL_INTERVAL_MS = 15_000

export function useSessionReplacedPoll(enabled: boolean) {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => {
    if (!enabled) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
      return
    }

    const checkSession = async () => {
      try {
        await apiRequest<{ success: boolean }>('/api/v1/user-auth/profile', { method: 'GET' })
      } catch {
        // apiRequest จะจัดการ 401 SESSION_REPLACED (handleSessionReplaced) อยู่แล้ว
      }
    }

    checkSession()
    intervalRef.current = setInterval(checkSession, POLL_INTERVAL_MS)
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  }, [enabled])
}
